.updated {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}